import { render, staticRenderFns } from "./BrandLogos.vue?vue&type=template&id=4d8f9fc0&scoped=true"
import script from "./BrandLogos.vue?vue&type=script&lang=js"
export * from "./BrandLogos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d8f9fc0",
  null
  
)

export default component.exports